export { TopUpsellBannerPlaceHolder as TopUpsellBanner } from './components/TopUpsellBannerPlaceHolder';
